export default __webpack_public_path__ + "static/screenFifthSectionRu-894b817050e94aff5baf47b7db065e0a.webp";